import React, { useEffect, useState } from "react";
import { Grid, Card, Typography } from "@material-ui/core";
import Components from "./e_components";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import {  Alert } from "@material-ui/lab";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { routePaths } from "../config/route-paths";
import { history } from "../../helpers";
import { useTranslation } from "react-i18next";
import { updateSelectedVal } from "../e_layout/e_header/e_profile_dropdown/model/profile-action";
const useStyle = makeStyles((theme) => ({
  card1Height: {
    height: "83vh",
  },
  card2Height: {
    height: "49.5vh"
  },
  card3Height: {
    height: "32.2vh",
    ['@media (min-width:660px) and (max-width:800px)']: {
      height: "34.2vh",
    },
  },
  customHeight: {
    height: "100%"
  },
  tipPadding:{
    paddingTop:'0.5rem'
  },
  alert:{
    marginBottom:'0.5rem'
  }
}));

export default function Home() {
  let classes = useStyle();
  let dispatch = useDispatch();
  let widgets = useSelector((state) => state?.parametersWidgets?.WidgetLookUp);
  let isPrepaid = useSelector(
    (store) => store?.meterDetails?.getSaInfo?.isPrepaidSa
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  let [allData, setAlldata] = useState();
  const [migrated,setMigrated] = useState(false)
  const [showBanner,setShowBanner] = useState(false);
  const [orderWidgets, setOrderWidgets] = useState();
  const isDesktop = useMediaQuery({ minWidth: 1280 });
  const isMobile = useMediaQuery({ minWidth: 600 });
  const {t:label, ready: labelReady} = useTranslation("label-E_CUSTOMER_PROFILE");
  useEffect(()=>{
  },[labelReady,label])
let bearer = localStorage.getItem("bearer")
bearer = JSON.parse(bearer)
  useEffect(()=>{
    if(bearer?.migrateUser){
      setMigrated(bearer?.migrateUser)
    }else{
      setMigrated(false)
    }
  },[bearer])

  useEffect(() => {
    widgets &&
      widgets.map(
        (item) =>
          item.widgetCode === "E_SIDEBAR.HOME" && setAlldata(item.children)
      );
  }, [widgets]);

  console.log(orderWidgets)

  
    useEffect(()=>{
      let enabled_state_value=localStorage.getItem("enabled_state")
      if(enabled_state_value)
      localStorage.removeItem("enabled_state")
    },[])
  

  useEffect(() => {
    if (allData) {
      if (!isMobile) {
        allData.map((item) => {
          if (item.widgetRank === 1) {
            item.widgetRank = 2;
          }
          if (
            (item.widgetCode === "E_ACCOUNT_SUMMARY") &
            (item.widgetRank !== 1)
          ) {
            item.widgetRank = 1;
          }
        });
      } else {
        allData.map((item) => {
          if (item.widgetRank === 2) {
            item.widgetRank = 1;
          } else if (
            item.widgetRank === "E_ACCOUNT_SUMMARY" &&
            item.widgetRank === 1
          ) {
            item.widgetRank = 2;
          }
        });
      }

      let inOrder = allData.filter((i) => i.widgetDefaultValue === "true");
      inOrder.sort((a, b) => {
        return a.widgetRank - b.widgetRank;
      });

      setOrderWidgets(inOrder);
    }
  }, [allData, isMobile]);

  useEffect(()=>{
    if(localStorage.getItem('showBanner')==undefined){
      localStorage.setItem("showBanner",bearer?.isPinExpired)
    }
    setShowBanner(localStorage.getItem("showBanner"));
  },[])
  return (
    <>
    {(migrated || (migrated && bearer?.isTenant=="Y"))&& <Grid>
      <Alert severity="info" className={classes.alert}>
        <Typography variant="subtitle2" >{labelReady?label("E_MIGRATING_USERS_TEXT"):""} <Link style={{textDecoration:'underLine'}} href="" 
        onClick={() => history.push(routePaths.PROFILE,
          dispatch(updateSelectedVal(1)))}>
           {labelReady?label('E_MIGRATING_USERS_LINK'):""}</Link></Typography>
      </Alert>
    </Grid>}
    { !migrated&&bearer?.isTenant=="Y" && showBanner=='false' && <Grid>
      <Alert severity="info" className={classes.alert}>
        <Typography variant="subtitle2" >{labelReady?label("E_TENANT_ALERT"):""} <Link style={{textDecoration:'underLine'}} href="" 
        onClick={() => history.push(routePaths.PROFILE,
          dispatch(updateSelectedVal(1)))}>
           {labelReady?label('E_TENANT_LINK'):""}</Link></Typography>
      </Alert>
    </Grid>}
      {orderWidgets && orderWidgets.length > 0 ? (
        <Grid
          container
          spacing={1}
          style={{scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
          >
          <Grid
            item
            xs={12}
            sm={6}
            lg={
              orderWidgets?.[0]?.WidthWidget
                ? orderWidgets?.[0]?.WidthWidget
                : "3"
            }
          >
            <Card className={isDesktop ? classes.card1Height : classes.customHeight}
              style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"thin":"auto"}}
            >
              {Components(orderWidgets?.[0])}
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            lg={
              orderWidgets[1]?.WidthWidget ? orderWidgets[1]?.WidthWidget : "3"
            }
          >
            {isPrepaid !== "N" ? (
              <Grid  direction="column" spacing={1}>
                <Grid item>
                  <Card className={isDesktop ? classes.card2Height:classes.customHeight}
                   style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
                  >
                    {Components(orderWidgets?.[1])}
                  </Card>
                </Grid>
                <Grid item className={classes.tipPadding}>
                  <Card className={isMobile ? classes.card3Height : classes.customHeight}
                   style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
                  >
                    {Components(orderWidgets?.[2])}
                  </Card>
                </Grid>
              </Grid>
            ) : (
              <Card className={isDesktop ? classes.card1Height : classes.customHeight}
                style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
              >
                {Components(orderWidgets?.[1])}
              </Card>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={
              orderWidgets?.[3]?.WidthWidget
                ? orderWidgets?.[3]?.WidthWidget
                : "6"
            }
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Card className={isDesktop ? classes.card2Height:classes.customHeight}
                 style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
                >
                  {Components(orderWidgets?.[3])}
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={
                      orderWidgets?.[4]?.WidthWidget
                        ? orderWidgets?.[4]?.WidthWidget
                        : "6"
                    }
                  >
                    <Card className={isDesktop ? classes.card3Height:classes.customHeight}
                     style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
                    >
                      {Components(orderWidgets?.[4])}
                    </Card>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={
                      orderWidgets?.[5]?.WidthWidget
                        ? orderWidgets?.[5]?.WidthWidget
                        : "6"
                    }
                  >
                    <Card className={isDesktop ? classes.card3Height:classes.customHeight}
                     style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}}
                    >
                      {Components(orderWidgets?.[5])}
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Skeleton />
      )}
    </>
  );
}
